import { render } from "./CopyDay.vue?vue&type=template&id=c61f6a0a"
import script from "./CopyDay.vue?vue&type=script&lang=js"
export * from "./CopyDay.vue?vue&type=script&lang=js"

import exportComponent from "C:\\development\\AdmicomWeb\\AdmicomWeb.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__